import { getCollections } from '../api/client'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { CollectionGrid } from '../components/CollectionGrid'
import { Fehlerhinweis, Leerhinweis } from '../components/States'
import { useResource } from '../hooks/useResource'
import { useSeo } from '../hooks/useSeo'
import { useT } from '../i18n'
import { useShopConfig } from '../shopConfig'

export function CollectionsPage() {
  const t = useT()
  const { shopName, primaryHost } = useShopConfig()
  const { data, error, loading } = useResource((signal) => getCollections(signal), [])

  useSeo({
    title: t('sammlung.seoTitelAlle', { laden: shopName }),
    description: t('sammlung.seoTextAlle', { laden: shopName }),
    canonicalHost: primaryHost,
  })

  return (
    <>
      <Breadcrumbs
        pfade={[{ name: t('nav.startseite'), pfad: '/' }, { name: t('nav.sammlungen') }]}
      />
      {/* Derselbe Auftakt wie auf der Startseite ohne Bühne: eine Überschrift
          mit Luft, keine Zeile über dem Raster. */}
      <header className="auftakt">
        <h1>{t('nav.sammlungen')}</h1>
      </header>

      {loading && <Leerhinweis text={t('sammlung.laedt')} />}
      {error != null && <Fehlerhinweis fehler={error} />}
      {data?.length === 0 && <Leerhinweis text={t('sammlung.keine')} />}

      {data && data.length > 0 && <CollectionGrid sammlungen={data} />}
    </>
  )
}
